import { Box, Link, Typography } from "@mui/material";
import React from "react";

export type GroundingSource = {
  title: string;
  url: string;
};

type Props = {
  sources: GroundingSource[];
  timestamp?: string;
};

/**
 * Renders clickable web sources returned by Gemini Google Search grounding.
 * Placed below the assistant message bubble, above ThumbsResponse.
 * Renders nothing when sources is empty.
 */
const ChatSourcesList = ({ sources, timestamp }: Props) => {
  if (!sources || sources.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 0.75,
        pl: 1,
        pb: 1,
        maxWidth: "90%",
      }}
    >
      {timestamp && (
        <Typography
          variant="caption"
          sx={{
            color: "rgba(255,255,255,0.5)",
            fontSize: "11px",
            flexShrink: 0,
          }}
        >
          {new Date(timestamp).toLocaleString()}
        </Typography>
      )}
      {sources.map((source, index) => {
        const label =
          source.title?.trim() ||
          (() => {
            try {
              return new URL(source.url).hostname;
            } catch {
              return source.url;
            }
          })();
        return (
          <Link
            key={index}
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              fontSize: "11px",
              color: "rgba(255,103,45,0.85)",
              backgroundColor: "rgba(255,103,45,0.08)",
              borderRadius: "4px",
              px: 0.75,
              py: 0.25,
              "&:hover": { backgroundColor: "rgba(255,103,45,0.15)" },
            }}
          >
            {label}
          </Link>
        );
      })}
    </Box>
  );
};

export default React.memo(ChatSourcesList);
